__turbopack_context__.v({
  "tile": "ProductTile-module-scss-module__RV-Wwa__tile",
});
